import React from 'react'
import { motion } from 'framer-motion'

interface WaveformAnimationProps {
  isActive: boolean
  barCount?: number
  color?: string
  height?: number
}

/**
 * WaveformAnimation Component
 * Displays animated waveform visualization for speaking indicator
 */
export const WaveformAnimation: React.FC<WaveformAnimationProps> = ({
  isActive,
  barCount = 10,
  color = '#F5A623',
  height = 60,
}) => {
  const bars = Array.from({ length: barCount }, (_, i) => i)
  const darkerColor = adjustColorBrightness(color, 0.8)

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      gap: '6px',
      height: Math.min(height, 32) + 8 
    }}>
      {bars.map((index) => (
        <motion.div
          key={index}
          style={{
            width: 5,
            borderRadius: '9999px',
            background: `linear-gradient(to top, ${color}, ${darkerColor})`,
            boxShadow: isActive ? `0 0 10px ${color}50` : 'none',
          }}
          animate={
            isActive
              ? {
                  height: [8, Math.min(height * 0.6, 24), 8],
                }
              : {
                  height: 8,
                }
          }
          transition={{
            duration: 1.0,
            repeat: isActive ? Infinity : 0,
            ease: 'easeInOut',
            delay: index * 0.08,
          }}
        />
      ))}
    </div>
  )
}

function adjustColorBrightness(color: string, factor: number): string {
  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  const adjustedR = Math.round(r * factor)
  const adjustedG = Math.round(g * factor)
  const adjustedB = Math.round(b * factor)

  const toHex = (n: number) => {
    const hex = n.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }

  return `#${toHex(adjustedR)}${toHex(adjustedG)}${toHex(adjustedB)}`
}

export default WaveformAnimation
